import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate, useParams  } from "react-router-dom";
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputTextarea } from 'primereact/inputtextarea';
import { productUnitData } from '../../../services/serviceHubStore';
import store from '../../../services/store';
import { InputText } from 'primereact/inputtext';
import helpers from '../../../services/helpers';
import RenderErrors from '../../elements/RenderErrors';
import InvoiceListModal from '../../modals/InvoiceListModal';
import ContactListModal from '../../modals/ContactListModal';
import BrandFormModal from '../../modals/BrandFormModal';
import { getItemEnums } from '../../../services/apiService';
import { getApiData } from '../../../services/apiService';
import Swal from 'sweetalert2';
import { Checkbox } from 'primereact/checkbox';
 
export default function ProductUnitInputs ({ 
        ref_id = "",
        setLoading={},
        setFormData={},
        form_data,
        errors
    }){
    //const [errors, setErrors] = useState([]);
    const [enums, setEnums] = useState(store.order_enums);
    const [invoice_modal, setInvoiceModal] = useState(0);
    const [customer_modal, setContactModal] = useState(0);
    const [show_brand_modal, setShowBrandModal] = useState(0);
     const dropdownRef = useRef(null);
    const [has_polarcare, setHasPolarCare] = useState(false);
    
    useEffect(() => {
        fetchEnums()
    }, []);
    
    useEffect(() => {
        setHasPolarCare(Boolean(form_data.polarcare_plus))
    }, [form_data]);

    const fetchEnums = async () => {
        setLoading(true)
        const res = await getItemEnums()
        if(res){
            setEnums(res)
            setLoading(0)
        }
    }
    
    function inputChange(e) {
        const { name, type, checked, value: rawValue, files } = e.target;
        let value;

        // Normalize value based on input type
        switch (type) {
            case "checkbox":
                value = checked ? 1 : 0;
                // if (name === "polarcare_plus") {
                //     let polarcare_plus = checked ? true : false;
                //     setHasPolarCare(polarcare_plus)
                // }
                break;
            case "file":
                value = files?.[0] ?? null;
            break;
            default:
                value = rawValue;
        }

        // Build new state
        const new_state = { [name]: value };

        // Handle field-specific logic
        if (name === "order_no") {
            new_state.order_type = "";
            new_state.order_id = "";
        }

        if (name === "brand_id") {
            const brand = helpers.filterObject(enums.brand_list, value) ?? {};
            new_state.brand = brand?.brand_name ?? "";
        }

        setFormData(prev => ({ ...prev, ...new_state }));
    }

    const footerTemplate = () => {
        return (
            <div className='bg-light' style={{ padding: '10px', textAlign: 'center' }}>
                <button className="btn btn-primary btn-sm" type="button" onClick={handleAddBrand}>Add New <i className="fas fa-plus-circle" /></button>
            </div>
        );
    };

    const handleAddBrand = () => {
        dropdownRef.current?.hide();
        setShowBrandModal(1)
    };

    function handleCustomer(e){
        let data = {...form_data}
        data.customer_id = e.id ?? ''
        data.customer_name = e.contact_name ?? ''
        setFormData(data)
    }

    function handleInvoice(e){
        let data = {...form_data}
        data.order_type = ''
        data.order_id = e.id ?? ''
        data.order_no = e.invoice_no ?? ''
        data.purchased_date = new Date(e.invoice_date) ?? ''
        setFormData(data)
    }

    function handleBrandSave(e){
        let data = {...form_data}
        data.brand_id = e.id
        data.brand = e.brand_name

        setFormData(data)
        fetchEnums()
    }
    
    return (
        <div>
            <ContactListModal is_show={customer_modal} setShow={setContactModal} handleSelect={handleCustomer} />
            <InvoiceListModal   
                is_show={invoice_modal}  
                setShow={setInvoiceModal} 
                handleSelect={handleInvoice} 
                customer_id={form_data.customer_id}
            />
            <BrandFormModal 
                show_modal={show_brand_modal} 
                close_modal={setShowBrandModal} 
                handleSave={handleBrandSave}
            />
            <div>
                <div className="row">
                    <div className="col-md-3 col-lg-3 text-left text-md-left">
                        <label>QR Code</label>
                    </div>
                    <div className="col-md-5 col-lg-5 form-group">
                        <InputText
                            id="qr_code" 
                            name="qr_code" 
                            value={form_data.qr_code}
                            tagClass="form-control mb-0"
                            onChange={inputChange}
                            placeholder="QR Code"
                            
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="qr_code" 
                            className="text-danger"
                            style={{fontSize: '.9rem'}}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-lg-3 text-left text-md-left">
                        <label>Customer<span className="text-danger">*</span></label>
                    </div>
                    <div className="col-md-5 col-lg-5 form-group">
                        <div className="input-group">
                            {
                                ref_id ? <input type="text" className="form-control" placeholder="Select Customer" disabled={ref_id}  value={form_data.customer_name}  /> : <input type="text" className="form-control" placeholder="Select Customer" onClick={(e) => setContactModal(1)} value={form_data.customer_name} />
                            }

                            <div className="input-group-append">
                                <button className="btn btn-primary" type="button" onClick={(e) => setContactModal(1)} disabled={ref_id}><i className="fas fa-search" /></button>
                            </div>
                        </div>
                        <RenderErrors 
                            errors={errors} 
                            name="customer_name" 
                            className="text-danger"
                            style={{fontSize: '.9rem'}}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-lg-3 text-left text-md-left">
                        <label>Reference No</label>
                    </div>
                    <div className="col-md-5 col-lg-5 form-group">
                        <div className="input-group">
                            <input 
                                id="order_no" 
                                name="order_no" 
                                type="text" 
                                className="form-control" 
                                placeholder="Invoice No"
                                //disabled={ref_id} 
                                value={form_data.order_no}
                                onChange={inputChange}  
                            />

                            <div className="input-group-append">
                                <button className="btn btn-primary" type="button" onClick={(e) => setInvoiceModal(1)} disabled={!form_data.customer_id}><i className="fas fa-search" /></button>
                            </div>
                        </div>
                        <RenderErrors 
                            errors={errors} 
                            name="order_no" 
                            className="text-danger"
                            style={{fontSize: '.9rem'}}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-lg-3 text-left text-md-left">
                        <label>Purchased Date <span className="text-danger"></span></label>
                    </div>
                    <div className="col-md-5 col-lg-5 form-group">
                        <Calendar 
                            name="purchased_date"
                            placeholder="Purchased Date"
                            value={form_data.purchased_date} 
                            onChange={inputChange} 
                            className='w-100' 
                            dateFormat="yy-mm-dd" 
                            icon={() => <i className="far fa-calendar"></i>} 
                            showIcon  
                            
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="purchased_date" 
                            className="text-danger"
                            style={{fontSize: '.9rem'}}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-lg-3 text-left text-md-left">
                        <label>Brand<span className="text-danger">*</span></label>
                    </div>
                    <div className="col-md-5 col-lg-5 form-group">

                        <div>
                        <Dropdown  
                            ref={dropdownRef}
                            name='brand_id'
                            value={form_data.brand_id} 
                            onChange={inputChange} 
                            options={enums.brand_list} 
                            optionLabel="brand_name" 
                            optionValue="id" 
                            placeholder="Select Brand" 
                            className="w-100" 
                            checkmark={true} 
                            highlightOnSelect={false}
                            showClear
                            filter 
                            panelFooterTemplate={footerTemplate}
                            
                        />
                        </div>
                        <RenderErrors 
                            errors={errors} 
                            name="brand" 
                            className="text-danger"
                            style={{fontSize: '.9rem'}}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-lg-3 text-left text-md-left">
                        <label>Model <span className="text-danger"></span></label>
                    </div>
                    <div className="col-md-5 col-lg-5 form-group">
                        <InputText
                            id="model" 
                            name="model" 
                            value={form_data.model}
                            tagClass="form-control mb-0"
                            onChange={inputChange}
                            placeholder="Model"
                            
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="model" 
                            className="text-danger"
                            style={{fontSize: '.9rem'}}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-lg-3 text-left text-md-left">
                        <label>Indoor Serial No <span className="text-danger"></span></label>
                    </div>
                    <div className="col-md-5 col-lg-5 form-group">
                        <InputText
                            id="indoor_serial" 
                            name="indoor_serial" 
                            value={form_data.indoor_serial}
                            tagClass="form-control mb-0"
                            onChange={inputChange}
                            placeholder="Indoor Serial No"
                            
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="indoor_serial" 
                            className="text-danger"
                            style={{fontSize: '.9rem'}}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-lg-3 text-left text-md-left">
                        <label>Outdoor Serial No <span className="text-danger"></span></label>
                    </div>
                    <div className="col-md-5 col-lg-5 form-group">
                        <InputText
                            id="outdoor_serial" 
                            name="outdoor_serial" 
                            value={form_data.outdoor_serial}
                            tagClass="form-control mb-0"
                            onChange={inputChange}
                            placeholder="Outdoor Serial No"
                            
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="outdoor_serial" 
                            className="text-danger"
                            style={{fontSize: '.9rem'}}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-lg-3 text-left text-md-left">
                        <label>Cleaning Cycle Days<span className="text-danger">*</span></label>
                    </div>
                    <div className="col-md-5 col-lg-5 form-group">
                        <InputText
                            name="cleaning_cycle_days" 
                            value={form_data.cleaning_cycle_days}
                            inputClassName="form-control"
                            onChange={inputChange}
                            placeholder="Days"
                            keyfilter="num"
                            //readOnly={form_data.status_id == 5 || form_data.status_id == 6 || form_data.status_id == 7 || form_data.status_id == 8}
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="cleaning_cycle_days" 
                            className="text-danger"
                            style={{fontSize: '.9rem'}}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-lg-3 text-left text-md-left">
                        <label>Unit Location <span className="text-danger"></span></label>
                    </div>
                    <div className="col-md-5 col-lg-5 form-group">
                        <InputText
                            id="unit_location" 
                            name="unit_location" 
                            value={form_data.unit_location}
                            tagClass="form-control mb-0"
                            onChange={inputChange}
                            placeholder="Unit Location"
                            
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="unit_location" 
                            className="text-danger"
                            style={{fontSize: '.9rem'}}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-lg-3 text-left text-md-left">
                        <label className='mb-0'>Remarks</label>
                    </div>
                    <div className="col-md-5 col-lg-5 form-group">
                        <InputTextarea
                            id="remarks" 
                            name="remarks" 
                            value={form_data.remarks}  
                            className='w-100'
                            tagClass="form-control"
                            onChange={inputChange}
                            placeholder=""
                            rows={3}
                            
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="remarks" 
                            className="text-danger"
                            style={{fontSize: '.9rem'}}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12"><hr/></div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-lg-3 text-left text-md-left">
                        <label className='mb-0'>PolarCare+</label>
                    </div>
                    <div className="col-md-5 col-lg-5 form-group">
                        <Checkbox 
                            name="polarcare_plus"
                            id="polarcare_plus"
                            onChange={inputChange}
                            value={has_polarcare} 
                            checked={has_polarcare}
                        />
                        <RenderErrors 
                            errors={errors} 
                            name="polarcare_plus" 
                            className="text-danger"
                            style={{fontSize: '.9rem'}}
                        />
                    </div>
                </div>
                {
                    has_polarcare && 
                    
                    <div className="row">
                        <div className="col-md-3 col-lg-3 text-left text-md-left">
                            <label className='mb-0'>Start Date</label>
                        </div>
                        <div className="col-md-5 col-lg-5 form-group">
                            <Calendar 
                                name="polarcare_start_date"
                                placeholder="PolarCare+  Start Date"
                                value={form_data.polarcare_start_date} 
                                onChange={inputChange} 
                                className='w-100' 
                                dateFormat="yy-mm-dd" 
                                icon={() => <i className="far fa-calendar"></i>} 
                                showIcon 
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="polarcare_start_date" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}